import { Grid } from '@material-ui/core';
import { type ICourseReport } from 'src/models';
import { NoResults, ReportButtons } from 'src/components';
import { useEffect, useState } from 'react';

import CourseCard from '../CourseCard';
import CourseChart from '../CourseChart';
import QualificationsReportDialog from '../QualificationsReportDialog';

import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import courseActions from 'src/store/Courses/actions';

function Institution() {
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const reports = useSelector(
		(state: RootState) => state.courses.reports.institution,
	);
	const getReport = () => dispatch(courseActions.getReport('institution'));
	const [reportOpen, setReportOpen] = useState(false);

	useEffect(() => {
		getReport();
	}, []);

	return (
		<Grid container>
			<QualificationsReportDialog
				handleOpen={() => {
					setReportOpen(!reportOpen);
				}}
				open={reportOpen}
			/>

			<ReportButtons
				handleOpen={() => {
					setReportOpen(!reportOpen);
				}}
				type={'institution'}
			/>

			{reports.data?.length === 0 && (
				<NoResults text={'Aún no hay información'} />
			)}

			<Grid container spacing={2}>
				{reports.data.map((courseReport: ICourseReport) => (
					<CourseCard
						courseReport={courseReport}
						key={courseReport.id}
						type={'institution'}
					/>
				))}
			</Grid>

			<CourseChart type={'institution'} />
		</Grid>
	);
}

export default Institution;
